module.exports = __webpack_public_path__ + "img/Pekin_and_Pekin-Law-thumbnail.0f741a93.jpg";